/* pr-card-slider-safe.js (non-infinite, disable at ends) */
(function () {
  const SELECTOR = '.product-image[data-pr-slider="1"]';

  function normalizeUrl(url) {
    if (!url) return '';
    if (url.startsWith('//')) return 'https:' + url;
    return url;
  }

  function setBg(card, url) {
    const bg = card.querySelector('.nt_bg_lz');
    if (!bg || !url) return;
    bg.style.backgroundImage = `url("${normalizeUrl(url)}")`;
    bg.style.backgroundSize = 'cover';
    bg.style.backgroundPosition = 'center';
    bg.style.backgroundRepeat = 'no-repeat';
  }

  function getImages(card) {
    let images = [];
    try {
      images = JSON.parse(card.getAttribute('data-images') || '[]');
    } catch (e) {
      return [];
    }
    if (!Array.isArray(images)) return [];
    return images
      .map(x => ({ ...x, src: normalizeUrl(x && x.src) }))
      .filter(x => x && x.src);
  }

  function init(card) {
    if (card.querySelector('.pr_slide_btn')) return;

    const images = getImages(card);
    if (images.length < 2) return;

    card.style.position = 'relative';

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'pr_slide_btn pr_slide_prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-006" viewBox="0 0 24 24"><g><path d="M16.736,3.417c0,0.169-0.059,0.319-0.176,0.449l-8.32,8.301l8.32,8.301c0.117,0.13,0.176,0.28,0.176,0.449s-0.059,0.319-0.176,0.449c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.149-0.075-0.215-0.127l-8.75-8.75c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449l8.75-8.75c0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176C16.677,3.098,16.736,3.248,16.736,3.417z"></path></g></svg>';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'pr_slide_btn pr_slide_next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24"><g><path d="M6.708,20.917c0-0.169,0.059-0.319,0.176-0.449l8.32-8.301l-8.32-8.301c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449c0.13-0.117,0.279-0.176,0.449-0.176c0.169,0,0.318,0.059,0.449,0.176l8.75,8.75c0.117,0.13,0.176,0.28,0.176,0.449c0,0.169-0.059,0.319-0.176,0.449l-8.75,8.75c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.15-0.075-0.215-0.127C6.767,21.236,6.708,21.086,6.708,20.917z"></path></g></svg>';

    card.appendChild(prev);
    card.appendChild(next);

    let idx = 0;

    function updateButtons() {
      // disable prev at first
      if (idx <= 0) prev.classList.add('is-disabled');
      else prev.classList.remove('is-disabled');

      // disable next at last
      if (idx >= images.length - 1) next.classList.add('is-disabled');
      else next.classList.remove('is-disabled');
    }

    function go(step) {
      const nextIdx = idx + step;

      // Stop at ends (no loop)
      if (nextIdx < 0 || nextIdx > images.length - 1) return;

      idx = nextIdx;
      setBg(card, images[idx].src);
      updateButtons();
    }

    // initial
    setBg(card, images[idx].src);
    updateButtons();

    function stop(e) {
      e.preventDefault();
      e.stopPropagation();
    }

    [prev, next].forEach(btn => {
      btn.addEventListener('click', stop);
      btn.addEventListener('mousedown', (e) => e.stopPropagation());
      btn.addEventListener('touchstart', (e) => {
        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });
    });

    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
  }

  function boot(root = document) {
    root.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }
  window.addEventListener('load', () => boot());

  document.addEventListener('shopify:section:load', () => boot());
  document.addEventListener('shopify:section:reorder', () => boot());
  document.addEventListener('shopify:section:select', () => boot());

  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches(SELECTOR)) init(node);
        if (node.querySelectorAll) node.querySelectorAll(SELECTOR).forEach(init);
      });
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });

  let tries = 0;
  const timer = setInterval(() => {
    boot();
    tries++;
    if (tries >= 10) clearInterval(timer);
  }, 500);
})();